import {commonActions} from '@gisatcz/ptr-state';
import ActionTypes from '../../../constants/ActionTypes';

export default {
	setActiveKey: commonActions.setActiveKey(
		ActionTypes.UNHAB.BENCHMARK_COMPARISON_TYPES,
	),
};
